import React from 'react';
import AdvisorApplicationsMain from './advisorApplicationsMain';
import TabbedPage from '../TabbedPage/tabbedPage';

const tabs = [
  {
    title: 'Browse All',
    id: 'main',
    component: () => <AdvisorApplicationsMain />
  }
];

export default () => {
  return (
    <div>
      <h1 className="main-pane-header">Advisor Applications</h1>
      <TabbedPage tabs={tabs} defaultTab="main" />
    </div>
  );
}
